// ... same imports
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Link } from "react-router-dom";

gsap.registerPlugin(useGSAP);

export default function Banner() {
  const container = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);
  const para1Ref = useRef(null);
  const para2Ref = useRef(null);
  const linkRef = useRef(null);
  const tagsRef = useRef(null);

  // const tags = [
  //   "Keynote Sessions",
  //   "Global Networking",
  //   "Interactive Workshops",
  // ];

  useGSAP(
    () => {
      const tl = gsap.timeline();
      tl.from(titleRef.current, {
        y: -100,
        opacity: 0,
        duration: 1.2,
        ease: "power2.out",
      })
        .from(
          subtitleRef.current,
          {
            y: -60,
            opacity: 0,
            duration: 1,
            ease: "power2.out",
          },
          "-=1"
        )
        .from(
          para1Ref.current,
          {
            x: -60,
            opacity: 0,
            duration: 1,
            ease: "power2.out",
          },
          "-=0.6"
        )
        .from(
          para2Ref.current,
          {
            x: 60,
            opacity: 0,
            duration: 1,
            ease: "power2.out",
          },
          "-=0.7"
        )
        .from(
          linkRef.current,
          {
            y: 80,
            opacity: 0,
            duration: 0.8,
            ease: "power2.out",
          },
          "-=0.5"
        )
        .from(
          tagsRef.current,
          {
            opacity: 0,
            scale: 0.8,
            duration: 0.8,
            ease: "back.out(1.7)",
          },
          "-=0.6"
        );
    },
    { scope: container }
  );

  return (
    <section
      ref={container}
      id="banner"
      className="relative text-white font-outfit flex flex-col items-center text-center xs:py-[3.5rem] xxs:py-[3rem] py-20 px-[2rem] overflow-hidden"
      style={{
        background:
          "linear-gradient( rgba(8,16,63,255) 17%, rgba(64, 224, 208, 1) 120%)",
      }}
    >
      <h1
        ref={titleRef}
        className="mb-8 text-5xl md:text-7xl xxs:text-4xl font-extrabold tracking-tight leading-tight text-white"
        style={{ textShadow: "0 4px 20px rgba(0, 0, 0, 0.4)" }}
      >
        Shaping the Future of Global Governance
      </h1>

      {/* <h1
        ref={subtitleRef}
        className="mb-6 text-4xl md:text-4xl xs:text-[28px]  xxs:text-[28px] font-black tracking-wide text-white"
      >
        TIRANA 2025
      </h1> */}
      <p className="mb-6 font-semibold text-lg md:text-xl text-white"></p>
      <p
        ref={para1Ref}
        className="mt-2 max-w-2xl text-[22px] md:text-xl xxs:text-[18px] leading-relaxed opacity-90"
      >
        Join us at the International Governance Conference to explore critical
        global issues and drive impactful change
      </p>

      <p
        ref={para2Ref}
        className="mt-20 font-semibold text-lg md:text-[27px] xxs:mt-[3rem] text-[23px] text-white"
      >
        Queen Geraldine Premier Event Hall, Hotel Plaza
      </p>
      <p className="mt-3 font-semibold text-lg md:text-[27px] text-[23px] text-white">
        Tirana | September 10th, 2025
      </p>

      {/* <div
        ref={tagsRef}
        className="mt-[6rem] lg:mt-[8rem] xxs:mt-[3rem] flex flex-wrap justify-center gap-4 text-sm uppercase tracking-wide"
      >
        {tags.map((tag, index) => (
          <span
            key={index}
            className="bg-white/10 px-4 py-1 rounded-full border border-white/20 backdrop-blur-sm"
          >
            {tag}
          </span>
        ))}
      </div> */}
      <Link
        to="/register"
        className="mt-16 inline-block bg-white text-brandBlue text-lg font-bold py-3 px-10 rounded-xl hover:bg-brandGreen hover:text-white transition-all shadow-xl"
      >
        Register Now
      </Link>
    </section>
  );
}
